import PlayerConstants from "../../../shared/constants/player";

const { PLAYBACK_TYPES, BINGE_WATCH_CARD_THRESHOLD, BOOKMARK_TITLE } = PlayerConstants;
const { RECORDING } = PlayerConstants.PLAYER_TYPE;

export const playerBuildBookmark = (
  isOnDemandType,
  playerMgr,
  recordingStopDeltaTime,
  videoExitThreshold,
  recordingStartDeltaTime,
  type,
  playbackType,
  externalContentId,
  bookmarkCreated,
  activeExtendedMetadata,
  isUpdatingBookmark = false,
  userRecordingStartTime
) => {
  let bookmarkInfo;
  if (isOnDemandType && playerMgr?.current) {
    const isLiveContent = playerMgr.current?.isLive();
    const currentTime = playerMgr.current?.getCurrentTime();
    if (currentTime) {
      const finishedThreshold = (BINGE_WATCH_CARD_THRESHOLD / 100) * playerMgr.current?.getDuration();

      let startDeltaTime = Math.round(currentTime);
      if (isLiveContent && currentTime >= userRecordingStartTime / 1000) {
        //For live recordings, the player returns a timestamp in milliseconds representing an absolute datetime value.
        // This returned datetime is relative to the original broadcast time rather than the playback session.
        startDeltaTime = Math.round(currentTime - userRecordingStartTime / 1000);
      } else if (recordingStartDeltaTime !== null) {
        // Previously, the bookmark startDeltaTime is relative to beginning of playback segments for both VOD and recording assets. Currently, the recording bookmark startDeltaTime needs to be relative to recordingStartDeltaTime.
        startDeltaTime = Math.round(currentTime - recordingStartDeltaTime);
      }

      bookmarkInfo = {
        bookmarkTitle: BOOKMARK_TITLE,
        startDeltaTime,
        isComplete: isUpdatingBookmark
          ? false
          : (isLiveContent ? startDeltaTime : Math.round(currentTime)) >= Math.round(finishedThreshold),
      };

      if (isUpdatingBookmark) {
        // payload will be used for PUT BOOKMARKS call
        if (bookmarkCreated.current) {
          bookmarkInfo.bookmarkId = bookmarkCreated.current.bookmarkId;
          bookmarkInfo.bookmarkTitle = bookmarkCreated.current.bookmarkTitle || BOOKMARK_TITLE;
        } else {
          console.error("Attempting to update a bookmark, but no existing bookmark was found");
        }
      } else {
        // payload will either be used for stop content or POST BOOKMARKS call
        if (activeExtendedMetadata.current?.dlum) {
          bookmarkInfo.uaId = activeExtendedMetadata.current.dlum.uaId;
          if (playbackType === PLAYBACK_TYPES.EPISODE) {
            bookmarkInfo.uaSeriesId =
              activeExtendedMetadata.current.dlum.series?.uaId || activeExtendedMetadata.current.dlum.uaGroupId;
            bookmarkInfo.season = parseInt(activeExtendedMetadata.current.season) || undefined;
            bookmarkInfo.episodeNumber = parseInt(activeExtendedMetadata.current.episodeNumber) || undefined;
          }
        } else {
          console.error("Attempting to create a new bookmark, but no DLUM data is available for the content");
        }

        // This is specific to cPVR where we're required to pass the externalContentId to bookmark call
        if (type === RECORDING) {
          bookmarkInfo.externalContentId = externalContentId;
        }
      }
    } else {
      console.error("Could not determine the current playback position for bookmark payload");
    }
  }

  return bookmarkInfo;
};
